import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { rem } from 'polished';
import { SingleSelect } from '@unmind/design-system';
import { Subtitle } from './styles';

export enum Cadence {
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Daily = 'DAILY',
}

export const SelectContainer = styled.div`
  width: 100%;
  margin: ${rem(12)} 0;
`;

interface CadenceDropdownProps {
  value: Cadence;
  onChange(field: string, value: Cadence): void;
}

const getDisplayText = (cadence: Cadence): string =>
  `add_to_calendar.cadence_dropdown.display_text.${cadence.toLowerCase()}`;

export const CadenceDropdown = ({ value, onChange }: CadenceDropdownProps) => {
  const { t: translate } = useTranslation('shared');
  const options = [
    Cadence.Once,
    Cadence.Daily,
    Cadence.Weekly,
    Cadence.Monthly,
  ];

  return (
    <>
      <Subtitle>{translate('add_to_calendar.modal.frequency')}</Subtitle>
      <SelectContainer>
        <SingleSelect
          id="cadence-select"
          placeholder={translate(
            'add_to_calendar.cadence_dropdown.placeholder',
          )}
          options={options.map(option => ({
            // @ts-ignore
            label: translate(getDisplayText(option)),
            value: option,
          }))}
          selectedValue={value}
          onChange={selection => onChange('cadence', selection as Cadence)}
          aria-label={translate(
            'add_to_calendar.cadence_dropdown.accessibility_label',
            { value },
          )}
        />
      </SelectContainer>
    </>
  );
};
